var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "700" } },
    [
      _c("w-card-title", [_vm._v(" " + _vm._s(_vm.title) + " ")]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: { label: _vm.$ct("view-name"), fancy: "" },
                    model: {
                      value: _vm.view.Name,
                      callback: function ($$v) {
                        _vm.$set(_vm.view, "Name", $$v)
                      },
                      expression: "view.Name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm.supplierFilter
            ? _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    { attrs: { xs: "12" } },
                    [
                      _c("app-contact-search", {
                        attrs: {
                          "group-id": [2],
                          "disable-create": "",
                          fancy: "",
                          label: _vm.$ct("supplier-filter"),
                          icon: "times",
                          "icon-tooltip": _vm.$ct("clear-supplier-filter"),
                        },
                        on: {
                          input: function ($event) {
                            return _vm.onSupplierSelect($event)
                          },
                          "icon-click": function ($event) {
                            return _vm.clearSupplier()
                          },
                        },
                        model: {
                          value: _vm.supplier,
                          callback: function ($$v) {
                            _vm.supplier = $$v
                          },
                          expression: "supplier",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c("app-columns-edit", {
        attrs: { view: _vm.view, "available-columns": _vm.availableColumns },
      }),
      _c(
        "w-card-actions",
        [
          _c(
            "w-button",
            {
              staticClass: "cancel",
              attrs: { disabled: _vm.isSaving, icon: "ban" },
              on: {
                click: function ($event) {
                  return _vm.close()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.cancel")))]
          ),
          _c("w-spacer"),
          _c(
            "w-button",
            {
              attrs: { disabled: !_vm.valid || _vm.isSaving, icon: "save" },
              on: {
                click: function ($event) {
                  return _vm.save()
                },
              },
            },
            [_vm._v(_vm._s(_vm.$ct("common.save")))]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }